<template>
  <div class="gpt-editor-modelSettings">
    <div v-if="settings" class="content">
        <el-form :model="settings" label-width="10em" label-suffix="：" class="el-drawer-content">
            <el-form-item label="maxLength">
                <el-input-number v-model="settings.maxLength" size="small" />
                <el-slider v-model="settings.maxLength" :min="1" :max="2048"></el-slider>
            </el-form-item>
            <el-form-item label="contextLimit">
                <el-input-number v-model="settings.contextLimit" size="small" />
                <el-slider v-model="settings.contextLimit" :min="0" :max="10" :step="1"></el-slider>
            </el-form-item>
            <el-form-item label="temperature">
                <el-input-number v-model="settings.temperature" size="small" :step="0.01" :precision="2"/>
                <el-slider v-model="settings.temperature" :min="0" :max="1" :step="0.01" ></el-slider>
            </el-form-item>
        </el-form>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
export default {
    name: 'gpt-editor-modelSettings',
    data () {
        let settings = null;
        return { settings };
    },
    props: {
        value: {
            type: Object,
            default: null
        }
    },
    watch: {
        value: {
            handler (val) {
                this.settings = val;
            },
            deep: true,
            immediate: true
        },
        settings: {
            handler (val) {
                this.$emit('update:value', val);
            },
            deep: true
        }
    },
};
</script>
<style scoped lang="scss">
.gpt-editor-modelSettings {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 1em;
    background: var(--page-bg-img);
    background-size: cover;
    .el-form {
        .el-form-item {
            .el-input-number{
                width: 110px;
                }
            .el-slider{
                padding-left: 20px;
                display:inline-block;
                vertical-align: bottom;
                width:calc(100% - 110px);
            }
        }
    }
}
</style>
